/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetSchedulingDateAvailabilityRequest} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'
import {GetSchedulingDateAvailabilityResponse} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'


export const getSchedulingDateAvailability = (request: GetSchedulingDateAvailabilityRequest, options?: CashRequestOptions) => post<GetSchedulingDateAvailabilityRequest, GetSchedulingDateAvailabilityResponse>("/2.0/cash/get-scheduling-date-availability", request, {...options, rejectOnError: true })